import { Box, Toolbar, Typography } from '@mui/material';
import { bool, func, number, string } from 'prop-types';
import React, { memo } from 'react';
import { I18n } from 'utils/i18n';
import { useDebounceCallback } from 'utils/useDebounceCallback';
import ErrorCaption from './ErrorCaption';
import PeopleSelected from './PeopleSelected';
import Search from './Search';

const EnhancedTableToolbar = ({ onSearch, isFetching = false, selected, error = '' }) => {
  const handleSearch = useDebounceCallback(e => {
    onSearch(e.target.value);
  }, 700);

  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', pr: 1 }}>
      <Typography component="div" sx={{ fontWeight: 600 }} variant="subtitle1">
        {I18n.t('TeamDrawer.EmployeesTable.Select member for this team')}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
        <ErrorCaption>{error}</ErrorCaption>
        <PeopleSelected selected={selected} />
        <Search onChange={handleSearch} isFetching={isFetching} />
      </Box>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  selected: number.isRequired,
  error: string,
  onSearch: func.isRequired,
  isFetching: bool,
};

export default memo(EnhancedTableToolbar);
